<div style="border: 2px solid #E4E5E8;border-radius: 18px; margin-top: 10px;
box-sizing: border-box;width: 103%;">
    <div class="d-flex" style="padding: 15px">
        <span style="font-weight: 600;font-size: 14px;color: #000000">Your Salary</span>
        <div class="mx-2"
                style="background: #FFFFFF;
        border: 1px solid #E4E5E8;
        box-sizing: border-box;
        border-radius: 6px;
padding: 2px"
        ><span style="font-size: 14px;font-weight: 600;color: #182F7C">DELAYED</span></div>
        <span style="font-weight: 600;font-size: 14px;color: #000000">By 3 Days</span>
    </div>
    <div class="d-flex" style="padding: 15px">
        <span style="font-weight: 600;font-size: 14px;color: #000000">Payments Due</span>
        <div class="mx-2"
             style="background: #FFFFFF;
        border: 1px solid #E4E5E8;
        box-sizing: border-box;
        border-radius: 6px;
padding: 2px"
        ><span style="font-size: 14px;font-weight: 600;color: #182F7C">AED 5,000</span></div>
        <span style="font-weight: 600;font-size: 14px;color: #000000">By 28 May</span>
    </div>

    <div class="d-flex justify-content-center" style="padding: 15px">
        <span style="font-weight: 600;font-size: 14px;color: #000000">Account Balance</span>
    </div>
    <div class="d-flex justify-content-center" style="padding-bottom: 10px;">
        <div class="mx-2"
             style="background: #FFFFFF;
        border: 1px solid #E4E5E8;
        box-sizing: border-box;
        border-radius: 6px;
padding: 2px"
        ><span style="font-size: 14px;font-weight: 600;color: #182F7C">INSUFFIECINT</span></div>
    </div>
</div>
